module.exports = __webpack_public_path__ + "img/confluence.52a9d56c.png";